(function(){
  function svg(name){
    var icons={
      facebook:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 8.4V6.8c0-.8.2-1.3 1.3-1.3H17V2.2c-.8-.1-1.7-.2-2.5-.2-2.6 0-4.4 1.6-4.4 4.5v1.9H7.2V12h2.9v9.8h3.6V12h3l.5-3.6H14Z"/></svg>',
      instagram:'<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5.2"/><circle cx="12" cy="12" r="4.1"/><circle cx="17.4" cy="6.6" r="1.1"/></svg>',
      tiktok:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14.3 3v10.4a4.4 4.4 0 1 1-4.4-4.4c.4 0 .8.1 1.2.2v3.1a1.6 1.6 0 1 0 1.1 1.5V3h2.1c.4 2.3 1.8 3.8 4.1 4.2v3.1c-1.6-.1-3-.7-4.1-1.7Z"/></svg>'
    };
    return icons[name]||'';
  }
  function init(){
    var wrap=document.querySelector('.plawny-social');
    if(!wrap || wrap.getAttribute('data-plawny-social-ready')==='1') return;
    wrap.setAttribute('data-plawny-social-ready','1');
    wrap.innerHTML='';
    var links=[
      ['Facebook','https://www.facebook.com/plawnyshoes','facebook'],
      ['Instagram','https://www.instagram.com/plawnyshoes/','instagram'],
      ['TikTok','https://www.tiktok.com/@plawnyshoes','tiktok']
    ];
    links.forEach(function(item){
      var a=document.createElement('a');
      a.href=item[1];
      a.target='_blank';
      a.rel='noopener noreferrer';
      a.setAttribute('aria-label',item[0]+' Pławny Shoes');
      a.className='plawny-social-link plawny-social-'+item[2];
      a.innerHTML=svg(item[2]);
      wrap.appendChild(a);
    });
  }
  function css(){
    if(document.getElementById('plawny-social-icons-css')) return;
    var s=document.createElement('style');
    s.id='plawny-social-icons-css';
    s.textContent='.plawny-social{display:flex!important;gap:10px!important;align-items:center!important}.plawny-social a,.plawny-social-link{width:34px!important;height:34px!important;border:1px solid rgba(227,189,121,.58)!important;border-radius:999px!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;color:#d49a35!important;background:rgba(212,154,53,.045)!important;text-decoration:none!important;transition:transform .18s ease,background .18s ease,border-color .18s ease!important}.plawny-social a:hover,.plawny-social-link:hover{transform:translateY(-2px)!important;background:rgba(212,154,53,.16)!important;border-color:#e3bd79!important;color:#e3bd79!important}.plawny-social svg{width:18px!important;height:18px!important;display:block!important}.plawny-social svg path{fill:currentColor!important}.plawny-social svg rect,.plawny-social svg circle{fill:none!important;stroke:currentColor!important;stroke-width:1.9!important}.plawny-social-facebook svg path,.plawny-social-tiktok svg path{fill:currentColor!important;stroke:none!important}';
    document.head.appendChild(s);
  }
  function run(){css();init();}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
  window.addEventListener('load',run);
  setTimeout(run,500);
})();